module.exports = __webpack_public_path__ + "img/ring_y_l_null_null.6efbc212.png";